import { createConfig } from 'wagmi'
import { base } from 'viem/chains'
import { injected, walletConnect } from 'wagmi/connectors'

// Get projectId from WalletConnect Cloud
const projectId = '30cc931753f26e660cc712092ad216d0'

// Create wagmiConfig with explicit connectors
export const config = createConfig({
  chains: [base],
  connectors: [
    // Configure injected connector to specifically target Phantom
    injected({
      target: () => ({
        id: 'phantom',
        name: 'Phantom',
        provider: typeof window !== 'undefined' ? (window as any).phantom?.ethereum : undefined,
      }),
    }),
    walletConnect({
      projectId,
      metadata: {
        name: 'SwordScan',
        description: 'The premier analytics platform for Bittensor subnets',
        url: 'https://swordscan.io',
        icons: ['https://i.ibb.co/p6tjyT7C/676ef7b23bdebce80077f770.jpg']
      },
    }),
  ],
})